// extracted by mini-css-extract-plugin
export default {"notification":"MessageBox_notification__FEqp9"};